<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="items"
      hide-actions
      class="elevation-1"
      pagination.sync="pagination"
      item-key="Id"
      loading="true"
    >
      <template v-slot:items="props">
        <td>{{ props.item.Name }}</td>
        <td>{{ props.item.IdentCode }}</td>
        <td>
          {{
            String(parseFloat(props.item.PriceWithoutVat).toFixed(2)).replace(
              '.',
              ','
            ) + ' Kč'
          }}
        </td>
        <td>{{ props.item.VatTariff + ' %' }}</td>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
export default {
  props: {
    url: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      items: [],
      headers: [
        { text: this.$t('ProductName'), value: 'Name' },
        { text: this.$t('IdentCode'), value: 'IdentCode' },
        { text: this.$t('PriceWithoutVat'), value: 'PriceWithoutVat' },
        { text: this.$t('VatTariff'), value: 'VatTariff' }
      ]
    }
  },
  methods: {
    async initialilze() {
      try {
        let res = await this.axios.get(this.url)
        this.items = res.data.Items
      } catch (error) {
        this.$root.$gerror(error.response.data)
      }
    },
    period(p) {
      switch (p) {
        case 0:
          return 'Trvalá'
        case 1:
          return 'Týdenní'
        case 2:
          return 'Měsíční'
        case 3:
          return 'Roční'
      }
    }
  },
  mounted() {
    this.initialilze()
  }
}
</script>
